module.exports = __webpack_public_path__ + "img/prop-trading-banner.10e6345b.png";